import { render, staticRenderFns } from "./iframeModal.vue?vue&type=template&id=5d288e3c"
import script from "./iframeModal.vue?vue&type=script&lang=js"
export * from "./iframeModal.vue?vue&type=script&lang=js"
import style0 from "./iframeModal.vue?vue&type=style&index=0&id=5d288e3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports